<template>
  <v-footer v-bind:style="{ 'border-top': '1px solid gray' }" class="px-4 footer">
    <v-container fluid>
      <v-row justify="end">
        <v-col class="text-right pa-0" cols="1">
          <v-icon v-bind:class="{ rotate: active }" class="icon" @click="toggleFooter">keyboard_arrow_up</v-icon>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-bind:style="{ maxHeight: height, padding: !active ? '0px' : '12px' }" id="footer-height">
      <v-row>
        <v-col class="text-center" md="3" cols="12">
          <div>
            <span class="non-wrap">{{ $t('footer.language') }} :</span>
            <SelectLang />
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="text-center" sm="4" md="3" cols="12">
          <p class="menu-title">{{ $t('footer.mobile') }}</p>
          <p>
            <a
              class="links"
              rel="noopener noreferrer"
              target="_blank"
              href="https://apps.apple.com/us/app/nextlane-inspect/id6465174617"
              ><v-icon>mdi mdi-apple-ios</v-icon></a
            >
          </p>
          <p>
            <a
              class="links"
              rel="noopener noreferrer"
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.nextlane.inspect.live"
              ><v-icon>mdi mdi-android</v-icon></a
            >
          </p>
        </v-col>
      </v-row>
      <v-row align="center" justify="space-around">
        <v-col class="text-md-left text-center" md="8" cols="12">
          <a class="links mr-2" :href="legalNoticeUrl">{{ $t('footer.legalNotice') }}</a>
          <a class="links mr-2" :href="cguUrl">{{ $t('footer.termsOfService') }}</a>
          <a class="links mr-2" :href="cgvUrl">{{ $t('footer.termsOfSales') }}</a>
          <a class="links mr-2" :href="privacyPolicyUrl">{{ $t('footer.privacyPolicy') }}</a>
        </v-col>
        <v-col class="text-md-right text-center" md="4" cols="12">
          <span class="margin-right">{{ $t('footer.copyright') }}</span>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import SelectLang from '@/components/SelectLang'

export default {
  name: 'Footer',
  components: {
    SelectLang
  },
  mounted() {
    this.resizeAndClose()
    window.addEventListener('resize', () => {
      this.resizeAndClose()
    })
  },
  data() {
    return {
      active: false,
      height: '0px'
    }
  },
  methods: {
    resizeAndClose() {
      this.height = '0px'
      this.active = false
    },
    toggleFooter() {
      this.active = !this.active
      this.height = this.active ? '2000px' : '0px'
      setTimeout(() => {
        const el = document.getElementById('footer-height')
        el.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
      }, 10)
    }
  },
  computed: {
    legalNoticeUrl() {
      return 'https://www.nextlane.com/legal-notice/'
    },
    cguUrl() {
      if (this.$i18n.locale === 'fr') {
        return 'https://stamp.yt/fr/home/conditions-generales-d-utilisation'
      } else {
        return 'https://en.stamp.yt/en/home/terms-of-use'
      }
    },
    cgvUrl() {
      if (this.$i18n.locale === 'fr') {
        return 'https://stamp.yt/fr/home/conditions-generales-de-vente'
      } else {
        return 'https://en.stamp.yt/en/home/gtcs'
      }
    },
    privacyPolicyUrl() {
      return 'https://www.nextlane.com/personal-data-protection-policy/'
    }
  }
}
</script>

<style lang="sass" scoped>
.footer
  overflow: hidden
  z-index: 99

#footer-height
  overflow: hidden

.links
  text-decoration: none
  text-align: center
  color: inherit
  cursor: pointer
  transition: all .2s ease-in-out
  opacity: .6
  &:hover
    opacity: 1

.menu-title
  text-transform: uppercase

.margin-right
  @media screen and (min-width: 1264px)
    margin-right: 15px

.alignment-left
  flex-direction: column
  align-items: center
  @media screen and (min-width: 1264px)
    flex-direction: row
    justify-content: flex-start

.alignment-right
  flex-direction: column
  align-items: center
  @media screen and (min-width: 1264px)
    flex-direction: row
    justify-content: flex-end

.container
  font-size: 14px
  font-weight: 300

.icon
  cursor: pointer
  transition: all .3s ease-in-out

.rotate
  transform: rotate(180deg)
</style>
